(function () {
    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {
        enumsTimePeriod(
            module.exports,
            require('lodash'),
            require('../../lib/riq-moment.js')
        );

    } else {
        RivalIQ.module('enums.timePeriod');

        enumsTimePeriod(
            RivalIQ.enums.timePeriod,
            window._,
            window.moment
        );
    }

    function enumsTimePeriod(enums, _, moment) {

        enums.bounds = {
            inclusive: 0x01,
            exclusive: 0x02
        };

        /**
         * An enum of intervals.
         */
        enums.interval = {
            // TODO `day` should be `date`, one day
            daily: 'day',
            weekly: 'week',
            monthly: 'month'
        };

        enums.intervalDropdownOptions = function (mainPeriodStart, mainPeriodEnd) {

            const numCompleteWeeks = RivalIQ.utils.timePeriod.numCompletePeriods(mainPeriodStart, mainPeriodEnd, 'week');
            const numCompleteMonths = RivalIQ.utils.timePeriod.numCompletePeriods(mainPeriodStart, mainPeriodEnd, 'month');

            return [{
                id: 'auto',
                name: 'Auto'
            }, {
                id: RivalIQ.enums.timePeriod.interval.daily,
                name: 'Day'
            }, {
                id: RivalIQ.enums.timePeriod.interval.weekly,
                name: 'Week',
                disabled: numCompleteWeeks < 2
            }, {
                id: RivalIQ.enums.timePeriod.interval.monthly,
                name: 'Month',
                disabled: numCompleteMonths < 2
            }];
        };

        /**
         * An enum of periods (the inverse of intervals).
         */
        enums.period = _.invert(enums.interval);

        enums.type = {
            LAST_SEVEN_DAYS: 1,
            LAST_THIRTY_DAYS: 2,
            LAST_NINETY_DAYS: 3,
            YESTERDAY: 4,
            THIS_WEEK: 5,
            LAST_WEEK: 6,
            THIS_MONTH: 7,
            LAST_MONTH: 8,
            NOT_AVAILABLE: 9,
            TODAY: 10,
            LOADING: 11,
            CUSTOM: 'custom',
            THIS_QUARTER: 12,
            LAST_QUARTER: 13
        };

        enums.periodType = {
            COMPARE_PERIOD: 1,
            MAIN_PERIOD: 2
        };

        enums.mainPeriodType = {
            LAST_SEVEN_DAYS: 0x1,
            LAST_THIRTY_DAYS: 0x2,
            LAST_NINETY_DAYS: 0x4,
            YESTERDAY: 0x8,
            THIS_WEEK: 0x10,
            LAST_WEEK: 0x20,
            THIS_MONTH: 0x40,
            LAST_MONTH: 0x80,
            TODAY: 0x100,
            CUSTOM: 0x200,
            THIS_QUARTER: 0x400,
            LAST_QUARTER: 0x800
        };

        enums.comparePeriodType = {
            PREVIOUS_PERIOD: 0x1,
            CUSTOM: 0x2,
            PREVIOUS_WEEK: 0x4,
            PREVIOUS_MONTH: 0x8,
            PREVIOUS_WHOLE_MONTH: 0x10,
            PREVIOUS_QUARTER: 0x20,
            PREVIOUS_WHOLE_QUARTER: 0x40,
            PREVIOUS_YEAR: 0x80
        };

        let valid = {};
        valid[enums.periodType.MAIN_PERIOD] = 2147483647;

        let apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_PERIOD;

        function toLandscapeTz(date, forceUtc) {

            if (forceUtc) {
                return moment.utc(date);
            }

            const timezone = RivalIQ.state.landscape.get('timezone') || RivalIQ.utils.timezone.getClientTimezoneString();
            let timezoneUtils;
            if (typeof window === 'undefined') {
                // Including these here to get around some module loading pain.
                timezoneUtils = require('../../public/modules/utils/timezone.js');
            } else {
                timezoneUtils = RivalIQ.utils.timezone;
            }

            return timezoneUtils.getDateInTimezone(timezone, date);
        }

        enums.comparePeriodDefinition = {};

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_PERIOD] = {
            id: enums.comparePeriodType.PREVIOUS_PERIOD,
            name: 'Previous Period',
            validWith: valid,
            dates: function (mainPeriodDates) {
                const diff = mainPeriodDates[1].diff(mainPeriodDates[0], 'day') + 1;

                return [
                    mainPeriodDates[0].clone().subtract(diff, 'day').startOf('day'),
                    mainPeriodDates[0].clone().subtract(1, 'day').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_YEAR] = {
            id: enums.comparePeriodType.PREVIOUS_YEAR,
            maxHistoryDaysRequired: 365,
            name: 'Previous Year',
            validWith: valid,
            showDisabledOption: function () {
                return RivalIQ.state.account.isTrialing();
            },
            dates: function (mainPeriodDates) {
                // NOTE: this will bump up to 366 if we cross feb 29 on a leap year
                const daysInYear = mainPeriodDates[1].diff(mainPeriodDates[1].clone().subtract(1, 'year'), 'day');
                return [
                    mainPeriodDates[0].clone().subtract(daysInYear, 'day').startOf('day'),
                    mainPeriodDates[1].clone().subtract(daysInYear, 'day').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.CUSTOM] = {
            id: enums.comparePeriodType.CUSTOM,
            name: 'Custom',
            validWith: valid,
            editable: true,
            isCustom: true,
            dates: function (mainPeriodDates, staticDates) {
                if (staticDates) {
                    return staticDates;
                }

                const diff = mainPeriodDates[1].diff(mainPeriodDates[0], 'day') + 1;

                return [
                    mainPeriodDates[0].clone().subtract(diff, 'day').startOf('day'),
                    mainPeriodDates[0].clone().subtract(1, 'day').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_WEEK] = {
            name: 'Previous Period',
            id: enums.comparePeriodType.PREVIOUS_WEEK,
            validWith: valid,
            dates: function (mainPeriodDates) {
                return [
                    mainPeriodDates[0].clone().subtract(7, 'day').startOf('day'),
                    mainPeriodDates[1].clone().subtract(7, 'day').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_MONTH] = {
            name: 'Previous Period',
            id: enums.comparePeriodType.PREVIOUS_MONTH,
            validWith: valid,
            dates: function (mainPeriodDates) {
                return [
                    mainPeriodDates[0].clone().subtract(1, 'month').startOf('day'),
                    mainPeriodDates[1].clone().subtract(1, 'month').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_WHOLE_MONTH] = {
            name: 'Previous Period',
            id: enums.comparePeriodType.PREVIOUS_WHOLE_MONTH,
            validWith: valid,
            dates: function (mainPeriodDates) {
                return [
                    mainPeriodDates[0].clone().subtract(1, 'month').startOf('month').startOf('day'),
                    mainPeriodDates[1].clone().subtract(1, 'month').endOf('month').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_QUARTER] = {
            name: 'Previous Period',
            id: enums.comparePeriodType.PREVIOUS_QUARTER,
            validWith: valid,
            dates: function (mainPeriodDates) {
                return [
                    mainPeriodDates[0].clone().subtract(1, 'quarter').startOf('day'),
                    mainPeriodDates[1].clone().subtract(1, 'quarter').endOf('day')
                ];
            }
        };

        enums.comparePeriodDefinition[enums.comparePeriodType.PREVIOUS_WHOLE_QUARTER] = {
            name: 'Previous Period',
            id: enums.comparePeriodType.PREVIOUS_WHOLE_QUARTER,
            validWith: valid,
            dates: function (mainPeriodDates) {
                return [
                    mainPeriodDates[0].clone().subtract(1, 'quarter').startOf('quarter').startOf('day'),
                    mainPeriodDates[1].clone().subtract(1, 'quarter').endOf('quarter').endOf('day')
                ];
            }
        };


        enums.mainPeriodDefinition = {};

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_PERIOD | enums.comparePeriodType.PREVIOUS_YEAR;

        enums.mainPeriodDefinition[enums.mainPeriodType.YESTERDAY] = {
            id: enums.mainPeriodType.YESTERDAY,
            name: 'Yesterday',
            timePeriodId: enums.type.YESTERDAY,
            dates: function (forceUtc) {
                const yesterday = toLandscapeTz(new Date(), forceUtc).subtract(1, 'day');
                return [
                    yesterday.clone().startOf('day'),
                    yesterday.endOf('day')
                ];
            },
            validWith: valid,
            apiValidWith: apiValid
        };

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_WEEK | enums.comparePeriodType.PREVIOUS_YEAR;
        apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_WEEK;

        enums.mainPeriodDefinition[enums.mainPeriodType.THIS_WEEK] = {
            id: enums.mainPeriodType.THIS_WEEK,
            name: 'This Week to Date',
            validWith: valid,
            apiValidWith: apiValid,
            timePeriodId: enums.type.THIS_WEEK,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).startOf('week').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };

        enums.mainPeriodDefinition[enums.mainPeriodType.LAST_WEEK] = {
            id: enums.mainPeriodType.LAST_WEEK,
            name: 'Last Week',
            validWith: valid,
            apiValidWith: apiValid,
            timePeriodId: enums.type.LAST_WEEK,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).startOf('week').subtract(1, 'week').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('week').subtract(1, 'week').endOf('day')
                ];
            }
        };

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_MONTH | enums.comparePeriodType.PREVIOUS_YEAR;
        apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_MONTH;

        enums.mainPeriodDefinition[enums.mainPeriodType.THIS_MONTH] = {
            id: enums.mainPeriodType.THIS_MONTH,
            name: 'This Month to Date',
            validWith: valid,
            apiValidWith: apiValid,
            timePeriodId: enums.type.THIS_MONTH,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).startOf('month').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_WHOLE_MONTH | enums.comparePeriodType.PREVIOUS_YEAR;
        apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_WHOLE_MONTH;

        enums.mainPeriodDefinition[enums.mainPeriodType.LAST_MONTH] = {
            id: enums.mainPeriodType.LAST_MONTH,
            name: 'Last Month',
            validWith: valid,
            apiValidWith: apiValid,
            timePeriodId: enums.type.LAST_MONTH,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).subtract(1, 'month').startOf('month').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).subtract(1, 'month').endOf('month').endOf('day')
                ];
            }
        };

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_QUARTER | enums.comparePeriodType.PREVIOUS_YEAR;
        apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_QUARTER;

        enums.mainPeriodDefinition[enums.mainPeriodType.THIS_QUARTER] = {
            id: enums.mainPeriodType.THIS_QUARTER,
            name: 'This Quarter to Date',
            validWith: valid,
            apiValidWith: apiValid,
            timePeriodId: enums.type.THIS_QUARTER,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).startOf('quarter').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_WHOLE_QUARTER | enums.comparePeriodType.PREVIOUS_YEAR;
        apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_WHOLE_QUARTER;

        enums.mainPeriodDefinition[enums.mainPeriodType.LAST_QUARTER] = {
            id: enums.mainPeriodType.LAST_QUARTER,
            name: 'Last Quarter',
            validWith: valid,
            apiValidWith: apiValid,
            timePeriodId: enums.type.LAST_QUARTER,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).subtract(1, 'quarter').startOf('quarter').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).subtract(1, 'quarter').endOf('quarter').endOf('day')
                ];
            }
        };

        const validWith = {};
        validWith[enums.periodType.MAIN_PERIOD] = 2147483647;
        validWith[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_PERIOD | enums.comparePeriodType.PREVIOUS_YEAR;
        apiValid = {};
        apiValid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.PREVIOUS_PERIOD;

        enums.mainPeriodDefinition[enums.mainPeriodType.LAST_SEVEN_DAYS] = {
            id: enums.mainPeriodType.LAST_SEVEN_DAYS,
            name: 'Last 7 Days',
            timePeriodId: enums.type.LAST_SEVEN_DAYS,
            validWith: validWith,
            apiValidWith: apiValid,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).subtract(6, 'days').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };

        enums.mainPeriodDefinition[enums.mainPeriodType.LAST_THIRTY_DAYS] = {
            id: enums.mainPeriodType.LAST_THIRTY_DAYS,
            name: 'Last 30 Days',
            timePeriodId: enums.type.LAST_THIRTY_DAYS,
            validWith: validWith,
            apiValidWith: apiValid,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).subtract(29, 'days').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };

        enums.mainPeriodDefinition[enums.mainPeriodType.LAST_NINETY_DAYS] = {
            id: enums.mainPeriodType.LAST_NINETY_DAYS,
            name: 'Last 90 Days',
            timePeriodId: enums.type.LAST_NINETY_DAYS,
            validWith: validWith,
            apiValidWith: apiValid,
            dates: function (forceUtc) {
                return [
                    toLandscapeTz(new Date(), forceUtc).subtract(89, 'days').startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };

        valid = _.clone(valid);
        valid[enums.periodType.COMPARE_PERIOD] = enums.comparePeriodType.CUSTOM | enums.comparePeriodType.PREVIOUS_PERIOD | enums.comparePeriodType.PREVIOUS_YEAR;

        enums.mainPeriodDefinition[enums.mainPeriodType.CUSTOM] = {
            id: enums.mainPeriodType.CUSTOM,
            name: 'Custom',
            editable: true,
            isCustom: true,
            timePeriodId: enums.type.CUSTOM,
            validWith: valid,
            dates: function (forceUtc, staticDates) {
                if (staticDates) {
                    return staticDates;
                }

                return [
                    toLandscapeTz(new Date(), forceUtc).startOf('day'),
                    toLandscapeTz(new Date(), forceUtc).endOf('day')
                ];
            }
        };
    }
})();
